import { render, staticRenderFns } from "./CashBookIndex.vue?vue&type=template&id=348c4bac&scoped=true"
import script from "./CashBookIndex.vue?vue&type=script&lang=js"
export * from "./CashBookIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c4bac",
  null
  
)

export default component.exports